import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import { Colors } from '../../../types/colors';
import './style.css';

type IProps = {
  children: ReactNode;
  color?: Colors;
  className?: string;
  style?: React.CSSProperties;
};

const Body = ({
  children,
  color = 'blue',
  className,
  ...props
}: IProps): ReactElement => {
  const textColors = {
    bone: 'text-type-bone',
    'purple-500': 'text-type-purple-500',
    'purple-400': 'text-type-purple-400',
    'purple-300': 'text-type-purple-300',
    'purple-200': 'text-type-purple-200',
    'purple-100': 'text-type-purple-100',
    purple: 'text-type-purple',
    gray: 'text-type-gray',
    blue: 'text-type-blue',
    yellow: 'text-type-yellow',
    pink: 'text-type-pink',
    teal: 'text-type-teal',
    black: 'text-type-black',
    white: 'text-type-white',
    success: 'text-type-success',
    error: 'text-type-error',
  };

  const textColorClass = textColors[color];

  return (
    <p className={`body ${textColorClass} ${className}`} {...props}>
      {children}
    </p>
  );
};

export default Body;
